import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

// Components that pages only reference through a dynamic tag
// (<component :is="embedded ? 'div' : 'v-main'">) are invisible to
// vuetify-loader's template scan, so it never auto-imports them and the tag
// renders as an unknown element with none of Vuetify's behaviour - v-main in
// particular stops offsetting the content for the app bar and the navigation
// drawer. Register them by hand so the dynamic form resolves.
import VMain from "vuetify/lib/components/VMain";
import VContainer from "vuetify/lib/components/VGrid/VContainer";
import { VCard, VCardText } from "vuetify/lib/components/VCard";
import VPagination from "vuetify/lib/components/VPagination";
import paginationItems from "@/utils/paginationItems";

Vue.use(Vuetify);

// Every <v-pagination> in the panel: by default Vuetify fills the row with as
// many page buttons as fit (1-18 ... 62-78 on a wide screen). Show the first
// five, "...", and the last five instead - see utils/paginationItems. Pages
// import the same VPagination through vuetify-loader, and each instance reads
// its computed properties from these options, so this covers all of them.
//
// Patch BOTH the merged options and the original extendOptions. VPagination's
// mixins (Colorable, Themeable) have computed props of their own, so
// options.computed is a separate merged copy of extendOptions.computed. When
// main.js later calls Vue.mixin(), Vue rebuilds every component's options from
// its extendOptions the first time it renders (resolveConstructorOptions) -
// patching only .options gets thrown away and Vuetify's default
// "1-18 ... 31-47" row comes back.
function pagedItems() {
  return paginationItems(this.length, this.value);
}
VPagination.options.computed.items = pagedItems;
if (VPagination.extendOptions && VPagination.extendOptions.computed) {
  VPagination.extendOptions.computed.items = pagedItems;
}

Vue.component("VMain", VMain);
Vue.component("VContainer", VContainer);
Vue.component("VCard", VCard);
Vue.component("VCardText", VCardText);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#CAB596",
        "primary-dark": "#8A6F4E",
        secondary: "#2E2A24",
        accent: "#8A6F4E",
        success: "#4C9A6A",
        error: "#D8564A",
        warning: "#E0A458",
        info: "#6E8FA3",
        background: "#f8f7fa",
        surface: "#FFFFFF",
      },
    },
    options: {
      customProperties: true,
    },
  },
});
